
import { useAuth } from "@/contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import { useEffect, ReactNode } from "react";

interface PasswordChangeGuardProps {
  children: ReactNode;
}

const PasswordChangeGuard = ({ children }: PasswordChangeGuardProps) => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // Only check after auth is loaded and user exists
    if (!loading && user && user.requiresPasswordChange) {
      console.log('🔐 Password change required, redirecting to change password page');
      navigate('/change-password', { replace: true });
    }
  }, [loading, user, navigate]);

  // Don't render children if password change is required
  if (!loading && user && user.requiresPasswordChange) {
    console.log('🔐 Blocking render - password change required');
    return null;
  }

  return <>{children}</>;
};

export default PasswordChangeGuard;
